/**
 * Created by zh on 21/09/17.
 */
import store from '@/store';
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
    const valid_map = ['admin', 'editor']
    return valid_map.indexOf(str.trim()) >= 0
}

/**
 * ���Ժϲ�����
 * @param {object} source
 * @param {object} target
 */
export function PropertyExtend(source, target) {
    var props = Object.getOwnPropertyNames(target);
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        if (prop == '__ob__') continue;
        if (target[prop] instanceof Object) {
            if (typeof target[prop] == 'function')
                source[prop] = target[prop];
            else if (Array.isArray(target[prop]))
                source[prop] = target[prop];
            else
                PropertyExtend(source[prop], target[prop]);
        }
        else {
            source[prop] = target[prop];
        }
    }
}

export function Print() {
    store.commit('app/SET_SIDESHOW', false);
    store.commit('app/SET_HEADSHOW', false);
    document.getElementsByClassName('el-tabs__header')[0].style.display = 'none';
    document.getElementsByClassName('el-main')[0].style.overflow = '';
    document.getElementsByClassName('el-tabs__content')[0].style.zoom = 0.6;
    
    setTimeout(() => {
        window.print();
        store.commit('app/SET_SIDESHOW', true);
        store.commit('app/SET_HEADSHOW', true);
        document.getElementsByClassName('el-tabs__header')[0].style.display = '';
        document.getElementsByClassName('el-main')[0].style.overflow = 'auto';
        document.getElementsByClassName('el-tabs__content')[0].style.zoom = 1;
    }, 300);
    //this.$nextTick(() => {
    //    window.print();
    //    this.$store.commit('app/SET_SIDESHOW', true);
    //    this.$store.commit('app/SET_HEADSHOW', true);
    //    document.getElementsByClassName('el-tabs__header')[0].style.display = '';
    //})
}